import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { AuthService } from 'src/app/providers/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-message-panel',
  templateUrl: './message-panel.component.html',
  styleUrls: ['./message-panel.component.scss']
})
export class MessagePanelComponent implements OnInit,OnDestroy {
  isMessagingListVisible: boolean = false;
  unreadCount: number = 0
  _apiSubscription: Subscription
  chatThreads: any[] = []
  loader: boolean = false
  notificationMessageCountData:any
  constructor(private _apiservice: ApiService, private authService: AuthService, private router: Router,private notificationService: NotificationService) {
    this.listenForMessageThreadUpdates();
    this._apiSubscription = this._apiservice.apiResult.subscribe((resData:any) =>{
      
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID){
        this.chatThreads = []
        
        if(resData.result){
          resData.result.forEach((element:any) => {
            if(element.senderInfo && element.receiverInfo){
              if(element.senderInfo && typeof element.senderInfo == 'string'){
                element.senderInfo = JSON.parse(element.senderInfo)
              }
              if(element.receiverInfo && typeof element.receiverInfo == 'string'){
                element.receiverInfo = JSON.parse(element.receiverInfo)
              }
              let changedTime = this.formatTimeAgo(element.lastMessageTime)
              element.lastMTime = changedTime
              element.isSelected = 0
             
              this.chatThreads.push(element)
              
            }
          });
          // if(this.sThread && this.sThread != ''){
          //   const index = this.chatThreads.findIndex((item:any) => item.hash_id == this.sThread.hash_id)
          //   this.chatThreads[index].isSelected = 1
          // }
          
          this.sortMessagesByTime(this.chatThreads)
          if(this.chatThreads.length > 25){
            this.chatThreads.length = 25
          }
          console.log(this.chatThreads);
          
        }
        this.loader = false
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_MESSAGE_NOTIFICATION_STATUS){
        if(resData.result){
          this.notificationMessageCountData = resData.result
        }
      }
    })
   }

  ngOnInit(): void {
    this.authService.getRefreshToken()
    .then(token => {
      if(token){
        console.log('panel');
        
        this._apiservice.getMessagesByID()
      }
    })
    .catch(error => {
      console.error('Failed to retrieve token:', error); // This would rarely happen as it keeps retrying
    });
  }
  toggleMessagingList() {
    this.isMessagingListVisible = !this.isMessagingListVisible;

  }
  sortMessagesByTime(messages:any) {
    return messages.sort((a:any, b:any) => {
        const timeA = new Date(a.lastMessageTime).getTime();
        const timeB = new Date(b.lastMessageTime).getTime();
        return timeB - timeA;
    });
}
goToMessages(thread:any){
  this.toggleMessagingList()
  this.router.navigate(['/messages'],{queryParams: {threadId: thread.hash_id}})
}
formatTimeAgo(lastMessageTime: string): string {
  const currentTime: Date = new Date();
  const messageTime: Date = new Date(lastMessageTime);
  const timeDifference: number = currentTime.getTime() - messageTime.getTime();
  const seconds: number = Math.floor(timeDifference / 1000);
  const minutes: number = Math.floor(seconds / 60);
  const hours: number = Math.floor(minutes / 60);
  const days: number = Math.floor(hours / 24);
  
  if (seconds < 60) {
      return `${seconds}s ago`;
  } else if (minutes === 1) {
      return `1m ago`;
  } else if (minutes < 60) {
      return `${minutes}m ago`;
  } else if (hours === 1) {
      return `1h ago`;
  } else if (hours < 24) {
      return `${hours}h ago`;
  } else if (days === 1) {
      return `yesterday`;
  } else if (days <= 7) {
      return `${days}d ago`;
  } else {
      // If the date is beyond a week, return the original date
      return messageTime.toISOString().split('T')[0];
  }
}

private messagesubscription: Subscription = new Subscription();
listenForMessageThreadUpdates() {
  this.messagesubscription = this.notificationService.getNotificationByType('updateMessageThread')
    .subscribe(payload => {
      if(true){
        console.log('Message thread update:', payload);
        this._apiservice.getMessagesByID();
        

      }
    });
}

ngOnDestroy(): void {
  if (this.messagesubscription) {
    this.messagesubscription.unsubscribe();
  }
}
}
